<template>
  <form
    @submit.prevent="changePassword()"
    class="w-full h-full">
    <div class="col-span-6 flex flex-col mb-3">
      <label class="mb-2 text-xs text-white">Password Lama</label>
      <div class="relative">
        <input
          :type="typePasswordOld"
          v-model="passwordOld"
          class="form-input px-3 py-3 w-full h-8 rounded-md text-xs"
          required>
        <i
          @click="typePasswordOld = typePasswordOld === 'password' ? 'text' : 'password'"
          class="material-icons absolute top-0 right-0 flex w-10 h-8 text-lg justify-center items-center text-gray-500 cursor-pointer">
          {{ typePasswordOld === 'password' ? 'visibility' : 'visibility_off' }}
        </i>
      </div>
    </div>
    <div class="col-span-6 flex flex-col mb-3">
      <label class="mb-2 text-xs text-white">Password Baru</label>
      <div class="relative">
        <input
          :type="typePasswordNew"
          v-model="passwordNew"
          class="form-input px-3 py-3 w-full h-8 rounded-md text-xs"
          required>
        <i
          @click="typePasswordNew = typePasswordNew === 'password' ? 'text' : 'password'"
          class="material-icons absolute top-0 right-0 flex w-10 h-8 text-lg justify-center items-center text-gray-500 cursor-pointer">
          {{ typePasswordNew === 'password' ? 'visibility' : 'visibility_off' }}
        </i>
      </div>
    </div>
    <div class="flex justify-end">
      <button
        class="px-1 py-1 w-32 h-8 bg-green-500 text-white text-xs rounded-md"
        type="submit">Simpan</button>
    </div>
    <PopupMessage :message="message" :confirm="{ success: confirmSuccess }" />
  </form>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PopupMessage from './PopupMessage.vue'

export default {
  name: 'FormUpdatePassword',
  data: () => ({
    passwordOld: null,
    typePasswordOld: 'password',
    passwordNew: null,
    typePasswordNew: 'password'
  }),
  computed: {
    ...mapGetters(['message'])
  },
  components: {
    PopupMessage
  },
  methods: {
    ...mapActions(['toChangePassword']),
    ...mapMutations(['setMessage']),
    changePassword: async function () {
      await this.toChangePassword({
        password_old: this.passwordOld,
        password_new: this.passwordNew
      })
    },
    confirmSuccess: function () {

    }
  }
}
</script>
